import * as React from "react";
import Main from "./Main/Main";
import { isStringValidated } from "./Global/constants";
import { Provider } from "react-redux";
import store from "./Store/store";
import { Input, Label, Textarea, Tooltip } from "@fluentui/react-components";
import { Icon,  TextField } from "office-ui-fabric-react";
import { AuthService } from "../services/authService";
import { useGetSet } from "react-use";
import { SweetAlerts } from "./UtilityFunctions/SweetAlerts";
import axios from 'axios';
import { Info20Regular } from "@fluentui/react-icons";
import { initializeIcons } from "@fluentui/react";


let SiteResponse;
// let AccessTOKEN;
let SettingListID=1;
const WhiteHalfNavImage : any = require("../../../assets/icon-80.png")
function App({token, currentUser,siteURL}){
  const [siteURLValue,setsiteURLValue]=React.useState<any>(siteURL||"")
  // const [siteURLValue,setsiteURLValue]=React.useState<any>()
  const [TokenValue,setTokenValue]=React.useState(token||"")
  const [currentUserData,setCurrentUserData]=React.useState(currentUser||{})
  const [AccessErrorMessage,setAccessErrorMessage]=React.useState({
    errorMessage:"",
    isTokenExpired:false
  })
  const authService = new AuthService();
  const { SweetAlert: SweetalertLogin,SweetPrompt:SweetPromptLogin,SweetConfirmPrompt:SweetConfirmAccessPrompt ,SweetConfirmWithoutBtnPrompt:SweetConfirmWithoutBtnAccessPrompt} = SweetAlerts("#SweetalertLogin");
  const [runOrderWise,setRunOrderWise]=useGetSet({
    ShowEnterURL:false,
    ShowLogin:false,
    ShowApp:false,
    ShowTokenExpired:false
  })


React.useEffect(()=>{
  initializeIcons()
  // if(Object.keys(currentUserData)?.length>0){
  //   getSettingsListItems()
  // }

  setRunOrderWise((c)=>({
    ...c,
    ShowEnterURL:!isStringValidated(siteURLValue),
    ShowLogin:Object.keys(currentUserData)?.length==0||false,
    ShowApp:isStringValidated(siteURLValue)&&Object.keys(currentUserData)?.length>0&&isStringValidated(TokenValue)
  }))

},[])


// const signInOutlook =()=>{
//   let domainName = Office.context.mailbox.userProfile?.emailAddress?.split("@")[1]?.split(".")[0] || "";
//   const postData = {
//     UserTenant: domainName,
//   };
//   const url =
//     "https://prod-27.centralindia.logic.azure.com:443/workflows/abd0fd21d1e74a0d8799f663183f9199/triggers/manual/paths/invoke?api-version=2016-06-01&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=JCCa0LvJT0wMFUuDlG9gxjp-fEtpn5H2tuvvTho3_8s";
//   fetch(url, {
//     method: "POST",
//     headers: {
//       "Content-Type": "application/json",
//     },
//     body: JSON.stringify(postData),
//   })
//     .then((response) => {
//       if (!response.ok) {
//         throw new Error(`HTTP error! Status: ${response.status}`);
//       }
//       return response.json(); // Parse the JSON response
//     })
//     .then((data) => {
//       console.log("Response:", data?.d?.results[0]?.NewTenant?.split(".sharepoint.com")[0]?.split("//")[1]);
//       localStorage.setItem(
//         "TenantURL",
//         data?.d?.results[0]?.NewTenant?.split(".sharepoint.com")[0]?.split("//")[1]
//       );
//       //Need to remove site URL
//       // localStorage.setItem(
//       //   "SiteURL",
//       //  "https://cubicdirect.sharepoint.com/sites/CLM365_TeamSite"
//       // );
//       // setsiteURLValue("https://cubicdirect.sharepoint.com/sites/CLM365_TeamSite")
//     })
//     .then(async () => {
//       // await loadCertificate();
//       await loginWithCredential();
//       await getSettingsListItems();
//       // await getSettingsListItems();
//     })
//     .catch((error) => {
//       console.error("Error:", error);
//     });
// }



// async function checkTokenExpiration(SiteResponse) {
//  const AccessTOKEN = localStorage.getItem("CurrentToken");
//   if (isStringValidated(AccessTOKEN)) {
//     // if (SiteResponse == 404) {
//     //   // document.getElementById("afterLogin").style.display = "block";
//     //   // document.getElementById("beforeLogin").style.display = "none";
//     //   // document.getElementById("loader").style.display = "none";
//     //   // const dialog = document.getElementById("siteUrlDialog");
//     //   // dialog.showModal();
//     //   SiteResponse = "";
//     //   setRunOrderWise((c)=>({
//     //     ...c,
//     //     ShowLogin:false,
//     //     ShowApp:false,
//     //     ShowTokenExpired:true,
//     //   }))
//     // } else
//     // if (SiteResponse == 404) {
//     //   const Unauthorized = {
//     //     ErrorMessage: `It looks like you're not logged in or your session has expired. Please log in again to access this site`
//     //   };
//     //   setAccessErrorMessage(Unauthorized)
//     //   setRunOrderWise((c)=>({
//     //     ...c,
//     //     ShowLogin:false,
//     //     ShowApp:false,
//     //     ShowTokenExpired:true
//     //   }))
//     // }

//     //  else
//       if (SiteResponse == 401) {
//       // await RefreshToken();
//       // document.getElementById("afterLogin").style.display = "none";
//       // document.getElementById("siteUrlDialog").close();
//       // SiteResponse = "";
// const Unauthorized=`Your session has expired, or you are not currently logged in. Please log in again to continue accessing this app.`
//       // setAccessErrorMessage((c)=>({
//       //   ...c,
//       //   errorMessage:`Your session has expired, or you are not currently logged in. Please log in again to continue accessing this app.`,
//       //   isTokenExpired:true
//       // }))
//       setRunOrderWise((c)=>({
//         ...c,
//         ShowLogin:true,
//         ShowApp:false,
//         ShowTokenExpired:true
//       }))
//       SweetConfirmAccessPrompt('warning',Unauthorized).then((result)=>{
//         if(result.isConfirmed){
//           RefreshPage()
//         }
//       })
//     }
//    else if (SiteResponse == 403) {
//       // await RefreshToken();
//       // document.getElementById("afterLogin").style.display = "none";
//       // document.getElementById("siteUrlDialog").close();
//       // SiteResponse = "";
//       const Unauthorized =  `Looks like you don't have sufficient permissions of the site. Please contact with your site administrator.`
  
//       // setAccessErrorMessage((c)=>({
//       //   ...c,
//       //   errorMessage:Unauthorized,
//       //   isTokenExpired:false
//       // }))
//       // SweetAlertOk('error',`${Unauthorized}`)
      
//       setRunOrderWise((c)=>({
//         ...c,
//         ShowLogin:false,
//         ShowApp:false,
//         ShowTokenExpired:true
//       }))

//       SweetConfirmWithoutBtnAccessPrompt('warning',Unauthorized)
//     } else if(SiteResponse == 404){
//       const Unauthorized =  `It appears the system is not yet set up to continue this app. Please contact your app administrator for further assistance`
  
//       // setAccessErrorMessage((c)=>({
//       //   ...c,
//       //   errorMessage:Unauthorized,
//       //   isTokenExpired:false
//       // }))
    
//       // SweetAlertOk('error',`${Unauthorized}`)
      
//       setRunOrderWise((c)=>({
//         ...c,
//         ShowLogin:false,
//         ShowApp:false,
//         ShowTokenExpired:true
//       }))
//       SweetConfirmWithoutBtnAccessPrompt('warning',Unauthorized)
//     }
    
//     else if(SiteResponse=="UserNotExistInApp"){
//       const Unauthorized =  `You do not have access to the CLM365 - Contract Management app. Please contact your app administrator to request access.`;
//       // setAccessErrorMessage((c)=>({
//       //   ...c,
//       //   errorMessage:Unauthorized,
//       //   isTokenExpired:false
//       // }))
//       setRunOrderWise((c)=>({
//         ...c,
//         ShowLogin:false,
//         ShowApp:false,
//         ShowTokenExpired:true
//       }))
//       SweetConfirmWithoutBtnAccessPrompt('warning',Unauthorized)
//     }
    
//     else{
//       setRunOrderWise((c)=>({
//         ...c,
//         ShowLogin:false,
//         ShowApp:true,
//         ShowTokenExpired:false
//       }))
//       setAccessErrorMessage((c)=>({
//         ...c,
//         errorMessage:"",
//         isTokenExpired:false
//       }))
//     }
    
//     // else {
//     //   setRunOrderWise((c)=>({
//     //     ...c,
//     //     ShowLogin:false,
//     //     ShowApp:true,
//     //     ShowTokenExpired:false
//     //   }))
//     //   // document.getElementById("siteUrlDialog").close();
//     //   // document.getElementById("afterLogin").style.display = "block";
//     //   // document.getElementById("beforeLogin").style.display = "none";
//     // }
//   } else {
//     setRunOrderWise((c)=>({
//       ...c,
//       ShowLogin:true,
//       ShowApp:false,
//       ShowTokenExpired:false
//     }))
//     setAccessErrorMessage((c)=>({
//       ...c,
//       errorMessage:"",
//       isTokenExpired:false
//     }))
//     // await RefreshToken();

//   }
// }
// async function RefreshToken() {
//   await loginWithCredential()
//   // const loginRequest = {
//   //   scopes: [`https://${localStorage.getItem("MT365TenantName")}` + ".sharepoint.com/Sites.FullControl.All"],
//   // };
//   // const response = await msalInstance.acquireTokenSilent(loginRequest);
//   // localStorage.setItem("MailTracker365LoginAccessToken", response.accessToken);
  
//   await getSettingsListItems();
// }
const loginWithCredential=async()=>{
  try {
    let token = null
    const currentUserObject = {
      currentUserName:"",
      currentUserId: "",
      currentUserEmail: "",
      GUID: ''
    };
  
  
    // await getTenant()
    await authService.initialize();
    const authResult = await getCurrentUserDetails();
    const homeAccountId = authResult?.account?.homeAccountId || "";
    const userGuid = homeAccountId?.split(".")?.[0];
   
    if (authResult) {
  
      // Successfully authenticated
       token = authResult.accessToken;
       currentUserObject.currentUserName = authResult.account.name;
       currentUserObject.currentUserId = authResult.account.homeAccountId;
       currentUserObject.currentUserEmail = authResult.account.username;
       currentUserObject.GUID = userGuid
      
       setCurrentUserData(currentUserObject)
       setTokenValue(authResult.accessToken)
       const activityLogs=[]
       localStorage.setItem("CurrentToken", token);
      localStorage.setItem("CurrentUser", JSON.stringify(currentUserObject));
      localStorage.setItem("ActivityLogs", JSON.stringify(activityLogs));
  
        setRunOrderWise((c)=>({
          ...c,
          ShowLogin:false,
          ShowApp:true,
        }))
      
      console.log('Authentication successful:', authResult.account.username);
    }
  } catch (error) {
    console.error('Authentication error:', error);
    const errorData = {
      errorMessage: error.errorCode || 'Unknown error',
      message: error.errorMessage || error.message,
      errorCode: error.stack
    };
  }
  }

// async function getSettingsListItems() {
//   // document.getElementById("loader").style.display = "block";
//   // const siteUrl = localStorage.getItem("SiteURL");
//   console.log(`${localStorage?.getItem("CurrentToken")}`)
//   let TenantURL = `https://${localStorage?.getItem("TenantURL")}.sharepoint.com`;
//   try {
//     if (isStringValidated(TenantURL)) {
//       const apiUrl = `${TenantURL}/_api/web/lists/getbytitle('CLM365Settings')/items`;
//       await axios.get(apiUrl, {
//         headers: {
//           Authorization: `Bearer ${localStorage?.getItem("CurrentToken")}`, // Include the access token
//           Accept: "application/json;odata=nometadata",
//           "odata-version": "",
//         },
//       })
//         .then((response) => {
//           if (response.status !== 200) { 
//             SiteResponse = response.status; 
//             checkTokenExpiration(response.status); 
//             throw new Error(`HTTP error! Status: ${response.status}`);
//           }
//           return response.data; 
//         })
//         .then(async(data) => {
//           SettingListID = data?.value[0].ID;
//           localStorage.setItem("SiteURL",  data?.value[0]?.SiteUrl);
//           setsiteURLValue(data?.value[0]?.SiteUrl)

//          const appUsers=await fetchAppUsers()

//         //  const currentUserExist=appUsers?.filter(user=>user.key?.toLowerCase()==currentUserData?.currentUserEmail?.toLowerCase()&& user?.userStatus != 'Inactive');

//         //  if(currentUserExist?.length==0){
//         //   checkTokenExpiration(true)
//         //  }else{
//         //   checkTokenExpiration(false)
//         //  }
//         // checkTokenExpiration(false)
//           // localStorage.setItem("MailTrackerSiteURL", data?.value[0]?.SiteUrl);
//           // document.getElementById("loader").style.display = "none";
//           // localStorage.setItem("AppUrlLink", data?.value[0]?.AppUrl);
//           // document.getElementById("portalLink").href = data?.value[0]?.AppUrl;
//           ;

//         })
//         .catch((error) => {
//           console.error("Error fetching list items:", error);
//         });
//     }
//   } catch {
//     console.log("error while getting settings list data");
//   }
// }



async function getCurrentUserDetails(): Promise<any> {

return new Promise(async (resolve, reject) => {
  try {
    console.log("Parent: Initiating login");
    const authResult = await authService.login();
    console.log("Parent: Authentication successful", authResult);
    resolve(authResult);
  } catch (error) {
    console.error("Parent: Authentication failed", error);
    reject(error);
  }
});
}



// const fetchAppUsers=async ()=>{
//   const token = localStorage.getItem("CurrentToken");
//   const siteUrl = localStorage.getItem("SiteURL");
//   const url = "/_api/web/lists/getbytitle('CLM365Users')/items?$select=*,UserStatus,GuidID,SPUser/Title,SPUser/ID,SPUser/EMail&$expand=SPUser";
//   const allUsersOptions=[]
//   try {
//       const response = await axios.get(`${siteUrl}${url}`, {
//           headers: {
//             Accept: "application/json;odata=nometadata",
//             "odata-version": "",
//             Authorization: `Bearer ${token}`,
//           },
//         });
//         if (response.status!== 200) {
//           checkTokenExpiration(response.status)
//           return;
//         }
//         const items=response?.data.value||[]
//         items?.map((user)=>{
//           allUsersOptions.push({
//               key: user.email,
//               text: user?.SPUser?.Title,
//               id: user?.SPUser?.ID,
//               userStatus:user?.UserStatus
//           })
//         })
//       const currentUserDetails=  JSON.parse(localStorage.getItem("CurrentUser")||"{}")
//           const currentUserExist=allUsersOptions?.filter(user=>user.key?.toLowerCase()==currentUserDetails?.currentUserEmail?.toLowerCase()&& user?.userStatus != 'Inactive');

//          if(currentUserExist?.length==0){
//           checkTokenExpiration('UserNotExistInApp')
//          }else{
//           checkTokenExpiration(200)
//          }

       
//   } catch (error) {
//     if(error?.status){
//       checkTokenExpiration(error.status)
//     }
//       console.log(error)
//   }
// }

const submitSiteURl=()=>{
    const urlInput = siteURLValue?.trim();
    const tenantUrlPattern = /^https:\/\/[a-zA-Z0-9-]+\.((sharepoint\.com)|(onmicrosoft\.com))(\/.*)?$/;
         const siteUrlPattern = /^https:\/\/[a-zA-Z0-9-]+\.sharepoint\.com\/sites\/[a-zA-Z0-9-_]+$/;
 
  if (!isStringValidated(urlInput)) {
    SweetalertLogin("error", "Please enter site URL");
    return;
  }
 
  if (!siteUrlPattern.test(urlInput)) {
    SweetalertLogin( "error", "Invalid Site URL. Please use only the site root: https://tenantname.sharepoint.com/sites/yoursitename");
    return;
  }
    if (isStringValidated(urlInput)) {
  
      if (!tenantUrlPattern.test(urlInput)) {
        SweetalertLogin('error',`Invalid tenant URL. Please use a valid URL like https://tenantname.sharepoint.com`)
        setTimeout(() => {
          setRunOrderWise((c)=>({
            ...c,
            ShowEnterURL:true,
            // ShowLogin:false
          }))
        }, 1500);
        // messageLabel.textContent = 'Invalid tenant URL. Please use a valid URL like https://tenantname.sharepoint.com';
        return;
      }else{
        const tenantURL= urlInput?.split("/sites")[0]
        localStorage.setItem("SiteURL", urlInput);
        localStorage.setItem("TenantURL", tenantURL);
        
        SweetalertLogin('success','Site URL submitted successfully')
        setTimeout(() => {
          setRunOrderWise((c)=>({
            ...c,
            ShowEnterURL:false,
            ShowLogin:true
          }))
        }, 2000);
      }

    } else {
      SweetalertLogin('error',"Please enter site URL")
    }
}

const signOutCredential=()=>{
  SweetPromptLogin('warning','Are you sure you want to Sign out?').then((c)=>{
    if(c.isConfirmed){
      localStorage.clear();
      // document.getElementById("loginBtn").style.display = "flex";
      // document.getElementById("tasPaneComponent").style.display = "none";
      setsiteURLValue('');
      setTokenValue('');
      setCurrentUserData({})
      setRunOrderWise((c)=>({
        ...c,
        ShowEnterURL:true,
        ShowTokenExpired:false,
        ShowLogin:false
      }))
      // Office.addin.hide();
    }
  })

}
const clearLocalStorage=()=>{
  SweetPromptLogin('warning','Are you sure you want to Sign out?').then((c)=>{
    if(c.isConfirmed){
      localStorage.clear();
      // document.getElementById("loginBtn").style.display = "flex";
      // document.getElementById("tasPaneComponent").style.display = "none";
      setsiteURLValue('');
      setTokenValue('');
      setCurrentUserData({})
      setRunOrderWise((c)=>({
        ...c,
        ShowEnterURL:true,
        ShowTokenExpired:false,
        ShowLogin:false
      }))
      // Office.addin.hide();
    }
  })
}

const RefreshPage=()=>{
  localStorage.clear();
document.getElementById("tasPaneComponent").style.display = "none";
  setsiteURLValue('');
  setTokenValue('');
  setCurrentUserData({})
  setRunOrderWise((c)=>({
    ...c,
    ShowEnterURL:true,
    ShowTokenExpired:false,
    ShowLogin:false
  }))
}
  // React.useEffect(()=>{    
  //   localStorage.setItem("CurrentToken", token);
  //   localStorage.setItem("CurrentUser", JSON.stringify(currentUser));
  // },[])
  return (
    <Provider store={store} >
   
      <div id="SweetalertLogin">
    { runOrderWise()?.ShowEnterURL?
    <div className="dialogParent">
      <div className="dialogBox">


          {/* <h3 className="dialogHeading">Please enter CLM365-Contract Management site URL</h3> */}
          {/* <div className="textDiv dialogHeader">
        <div>CLM365 for Outlook</div>
   
         
         
        </div> */}

           <div className="HeadingImageLabel" style={{display:'flex',alignItems:'center',justifyContent:'center'}}>
              {/* Sign in to <br></br> */}
              <img src={WhiteHalfNavImage} style={{height:'30px',width:'30px'}}/>
              CLM365 for Outlook
            </div>
            <div className="headerSubText">
              <div>Easily integrate Microsoft Outlook with</div>
              {/* <div> </div> */}
              <div>Apps365's AI-powered Contract Management solution.</div>
              {/* <div></div> */}
            </div>
          <div className="dialogLabelField">
              <div style={{display:'flex'}}>
                <Label required style={{fontSize:'12px'}}>Enter CLM365 Sharepoint site URL</Label>
              <Tooltip withArrow content={"Please enter CLM365 - Contract Management site URL (ex:https://yourtenant.sharepoint.com/sites/yoursitename)"} relationship="label">
            <Info20Regular style={{ marginLeft: "5px" }} />
          </Tooltip>
                </div>
            <TextField  type="text"  placeholder="https://tenantname.sharepoint.com/sites/yoursitename" onChange={(ev,newVal)=>{
              setsiteURLValue(newVal)
            }} className="outlook-custom-textfield" title={siteURLValue??""}/>
          </div>
          <menu className="dialogButtons">
            <button className="priButton" value="confirm" id="saveSiteUrl" onClick={submitSiteURl}>Submit</button>
          </menu>
      </div>
      </div>:null}

 {(runOrderWise()?.ShowLogin&&(!runOrderWise()?.ShowEnterURL))?
 <>
   <div className="login_container" id="beforeLogin" >
        <div className="HeadingLabel">Sign in to <br></br> 
        CLM365 for Outlook</div>
        <div className="textDiv">
        <div>Contract Management 365 helps you manage</div>
        {/* <div> </div> */}
         <div>and track your contracts seamlessly.</div>
          {/* <div></div> */}
        </div>

        <div className="loginCard">
          <button id="loginBtn" className="Loginbtn" onClick={loginWithCredential}>
            <img
              src="https://upload.wikimedia.org/wikipedia/commons/4/44/Microsoft_logo.svg"
              alt="Microsoft Logo"
              className="logo"
            />
            Sign in with Microsoft
          </button>
        </div>
  
      </div>
            <div className="TermsConditions">
            By logging in, you agree to the <a href="https://www.apps365.com/end-user-license-agreement-eula/">Terms of Use</a>
          </div>
 </>

      :null}
  {(runOrderWise()?.ShowApp &&(!runOrderWise()?.ShowEnterURL&&!runOrderWise()?.ShowLogin))? <Main siteURL={siteURLValue} tokenvalue={TokenValue} currentUser={currentUserData} clearLocalStorage={RefreshPage}/>:null}
  {/* {
    (runOrderWise()?.ShowTokenExpired&&!runOrderWise()?.ShowLogin)?<>
     <div  className="dialogParent">
    <div className="dialogBox" style={{padding:'20px'}}>
    
      <div>
        <div style={{display:'flex',justifyContent:'center'}}>
        <img src="../../assets/close.png" style={{width: "20px"}} />
        </div>
    
      <div style={{textAlign:'center',padding:'10px 0px'}}>{AccessErrorMessage?.errorMessage}</div>
      </div>
 
      {  AccessErrorMessage?.isTokenExpired&&<div style={{display:'flex',justifyContent:'center'}}>
          <button className="RefreshbuttonStyles" onClick={RefreshPage}>Re Login</button>
        </div>}
        <div
          id="loader"
          className="loader"
          style={{display:'none',position:'absolute',top: '50%',left:'50%',transform:'translate(-50%, -50%)'}}
          // style="display: none; position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%)"
        >
          <div className="spinner"></div>
        </div>
      </div>
    </div> 

    

    </>:null
  } */}

{ ((runOrderWise()?.ShowApp||runOrderWise()?.ShowTokenExpired)&&(!runOrderWise()?.ShowLogin))?
 <div className="footerSection">
        <footer id="footer-partial" className="helpsection">
          <div className="wrapper" style={{marginLeft:'15px'}}>
            <a href="https://apps365.com/support" target="_blank" rel="noopener noreferrer"
              style={{fontSize:'12px',fontWeight:400,gap:'0px'}}>
                <Icon iconName="Help" style={{fontSize:'12px'}}/>Help</a>
            <div style={{fontSize:'12px',fontWeight:400}}>26.0312.1530.0000</div>
          </div>
          <div className="wrapper">
            <button id="logoutBtn" onClick={()=>{
                 if(runOrderWise()?.ShowTokenExpired){
                  clearLocalStorage()
              }else{
                signOutCredential()
              }
            }} style={{fontSize:'12px',fontWeight:400}}>Sign out</button>
          </div>
        </footer>
      </div>
      :null}

    </div>

    
 

    </Provider>
  );
};

export default App;
